import React from 'react';
import { Formik } from 'formik';
import Box from '@mui/material/Box';
import Button from '@mui/lab/LoadingButton';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { flow, initial } from 'lodash';
import Slider from '@mui/material/Slider';
import { useDispatch, useSelector } from 'react-redux';

import ButtonPayActionsComponent from '../components/ButtonPayActions.component';
import FieldCurrencyComponent, {
  FieldCurrencyComponentDigits,
} from '@giro/shared-components/Fields/FieldCurrency.component';
import FieldLabelFormikComponent from '@giro-pdv/components/FieldLabelFormik.component';

import TextFieldLabelComponent from '@giro-pdv/components/TextFieldLabel.component';

import PDVLayout from '../layouts/PDV.layout';

import UpdateAmountComponent from '../components/UpdateAmount.component';

import dialogSendPayment from '../store/dialogs/dialogSendPayment';
import dialogPay from '../store/dialogs/dialogPay';
import tablePayment from '../store/tablePayment';
import transactions from '../store/transactions';
import useAuthHook from '@giro/shared-hooks/useAuth.hook';
import clients from '../store/clients';

const FormGeral = () => {
  const dispatch = useDispatch();
  const { user } = useAuthHook();
  const client = useSelector(clients.selector.selectPayload);

  const dispatchRedux = {
    OPEN_PAYMENT: flow(dialogSendPayment.action.open, dispatch),
    OPEN_PAY: flow(dialogPay.action.open, dispatch),
    transactionsServicePost: flow(transactions.action.servicePost, dispatch),
    updateReturn: flow(tablePayment.action.updateReturn, dispatch),
    updateTypeTax: flow(tablePayment.action.updateTypeTax, dispatch),
  };

  const selectorRedux = {
    return: useSelector(tablePayment.selector.selectReturn),
    installmentSelected: useSelector(
      tablePayment.selector.selectInstallmentSelected
    ),
    transactionsLoading: useSelector(transactions.selector.selectLoading),
  };
  let transactionTypes: any[] = [];
  if (client) transactionTypes = client?.tipoTransacao?.split(',');

  const initialValues = {
    client: null,
    service: null,
    material: null,
    total: null,
    segment: '4',
    type_tax: ['ec', 'client'].includes(client?.taxaPadrao)
      ? client?.taxaPadrao
      : 'client',
  };

  const onSubmit = () => {};

  React.useEffect(() => {
    if (user?.user?.codes?.idClient === 1282) dispatchRedux.updateReturn(12);
  }, []);

  React.useEffect(() => {
    dispatchRedux.updateTypeTax(client?.taxaPadrao || 'client');
  }, [client?.taxaPadrao]);
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validateOnMount={true}
      enableReinitialize={true}
    >
      {({ values, setFieldValue }) => {
        return (
          <>
            <UpdateAmountComponent />
            <Box display="flex" flexDirection="column" gap={4}>
              <Box display="flex" flexDirection="column" gap={4}>
                <FieldLabelFormikComponent
                  size="small"
                  name="client"
                  label="Identificação do cliente"
                />
                {![11133, 11123, 11122].includes(
                  user?.user?.codes?.idClient
                ) && (
                  <Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
                    <FieldCurrencyComponentDigits
                      customInput={TextFieldLabelComponent}
                      size="small"
                      name="material"
                      label="Material"
                      onChange={(val) =>
                        setFieldValue(
                          'total',
                          Number(val) + Number(values.service)
                        )
                      }
                    />
                    <FieldCurrencyComponentDigits
                      customInput={TextFieldLabelComponent}
                      size="small"
                      name="service"
                      label="Serviços"
                      onChange={(val) =>
                        setFieldValue(
                          'total',
                          Number(values.material) + Number(val)
                        )
                      }
                    />
                  </Box>
                )}
                <FieldCurrencyComponentDigits
                  customInput={TextFieldLabelComponent}
                  size="small"
                  label="Total"
                  name="total"
                  disabled={
                    ![11133, 11123, 11122].includes(user?.user?.codes?.idClient)
                  }
                />
                <Box display="grid" gridTemplateColumns="1fr 1fr" gap={4}>
                  <Box display="flex" flexDirection="column">
                    <Typography variant="trasso_heading_small">
                      Tipo de taxa
                    </Typography>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="portador"
                      name="radio-buttons-group"
                      onChange={(ev, value) => {
                        setFieldValue('type_tax', value);

                        dispatchRedux.updateTypeTax(value);

                        if (value === 'ec') {
                          dispatchRedux.updateReturn(0);
                        }
                      }}
                    >
                      {(transactionTypes.includes('1') || !client) && (
                        <FormControlLabel
                          value="client"
                          checked={values.type_tax === 'client'}
                          control={
                            <Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: 'trasso.pink',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="trasso_body_medium"
                              color="trasso.purple.100"
                            >
                              Portador
                            </Typography>
                          }
                        />
                      )}
                      {(transactionTypes.includes('2') || !client) && (
                        <FormControlLabel
                          value="ec"
                          checked={values.type_tax === 'ec'}
                          control={
                            <Radio
                              sx={{
                                '&.Mui-checked': {
                                  color: 'trasso.pink',
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="trasso_body_medium"
                              color="trasso.purple.100"
                            >
                              EC
                            </Typography>
                          }
                        />
                      )}
                    </RadioGroup>
                  </Box>
                  <Box display="flex" flexDirection="column">
                    <Typography variant="trasso_heading_small">R</Typography>
                    <Slider
                      disabled={
                        (values.type_tax === 'client' ? false : true) ||
                        !!(user?.user?.codes?.idClient === 1282)
                      }
                      step={2}
                      sx={{
                        mt: 4,
                        '& .MuiSlider-track': {
                          border: 'none',
                          backgroundColor: 'trasso.gray.40',
                        },
                        '& .MuiSlider-thumb': {
                          height: 24,
                          width: 24,
                          backgroundColor: '#fff',
                          border: '4px solid currentColor',
                        },
                        '& .MuiSlider-valueLabel': {
                          lineHeight: 1.2,
                          fontSize: 12,
                          background: 'unset',
                          padding: 0,
                          width: 32,
                          height: 32,
                          backgroundColor: 'trasso.purple.60',
                        },
                      }}
                      size="small"
                      color="secondary"
                      aria-label="Small"
                      valueLabelDisplay="auto"
                      max={12}
                      value={selectorRedux.return}
                      onChange={(ev, value) => {
                        dispatchRedux.updateReturn(value);
                      }}
                      marks={[
                        {
                          value: 0,
                          label: (
                            <Typography
                              variant="trasso_body_small"
                              color="trasso.purple.100"
                            >
                              0
                            </Typography>
                          ),
                        },
                        {
                          value: 12,
                          label: (
                            <Typography
                              variant="trasso_body_small"
                              color="trasso.purple.100"
                            >
                              12
                            </Typography>
                          ),
                        },
                      ]}
                    />
                  </Box>
                </Box>
              </Box>
              <Box display="grid" gridTemplateColumns="1fr" gap={4}>
                <ButtonPayActionsComponent
                  loading={selectorRedux.transactionsLoading}
                  onClickPay={() =>
                    dispatchRedux.transactionsServicePost({
                      ...values,
                    })
                  }
                  disabledPay={
                    selectorRedux.transactionsLoading ||
                    selectorRedux.installmentSelected === null ||
                    Number((values as any).total) === 0
                  }
                  disabledSend={Number((values as any).total) === 0}
                />
              </Box>
            </Box>
          </>
        );
      }}
    </Formik>
  );
};

const GeralScreen = () => {
  return (
    <PDVLayout>
      <FormGeral />
    </PDVLayout>
  );
};

export default GeralScreen;
